import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Outlet } from 'react-router-dom';

import { Announcement } from '@/components/Announcement';
import { Footer } from '@/components/Footer';
import { ScrollToPagePosition } from '@/components/ScrollToPagePosition';
import { TopNavBar } from '@/components/TopNavBar';
import { AuthProvider } from '@/components/providers/AuthProvider';

export const MapLayout = () => {
    return (
        <AuthProvider>
            <ScrollToPagePosition />
            <Stack
                sx={{
                    backgroundColor: '#d0d5dd10',
                    height: '100vh',
                }}
            >
                <TopNavBar />
                <Announcement />
                <Box flexGrow={1} overflow="hidden">
                    <Outlet />
                </Box>
                <Footer marginTop={0.5} />
            </Stack>
        </AuthProvider>
    );
};
